import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const dialogRootEl = document.getElementById('dialog-root');
const appRootEl = document.getElementById('root');

// Check if we're in dialog mode (dialog-root exists) or main app mode (root exists)
if (dialogRootEl) {
  // Dialog mode - mount the dialog calculator
  console.log('Mounting dialog mode');
  import('./dialog/index').then(({ mountDialog }) => {
    mountDialog(dialogRootEl);
  });
} else if (appRootEl) {
  // Main app mode - mount the full application
  console.log('Mounting main app');
  const root = ReactDOM.createRoot(appRootEl);
  root.render(
    //<React.StrictMode>
      <App />
    //</React.StrictMode>
  );
} else {
  console.error('No valid root element found (neither #dialog-root nor #root)');
}

reportWebVitals();